<template lang="html">
  <!-- Print Invoice  -->
  <div class="">
    <iframe id="iframeReceipt" name="iframeReceipt" style="height:0;width:0;"></iframe>
    <section ref="invoice" style="display:none;" id="printableArea">
      <div>
        <center>
          <br />Order History | FirstCry.com <br />
          TAX INVOICE
        </center>
      </div>
      <table width="100%" cellspacing="0" style="" v-if="franchisee && invoiceDetail.warehouse">
        <tr>
          <td align="left" width="50%">
            <span class="franchiseeTable">To,</span><br />
            <span class="franchiseeTable">{{ franchisee.companyName }}</span
            ><br />
            <span class="franchiseeTable">{{ franchisee.trustName }}</span
            ><br />
            <span class="franchiseeTable">{{ franchisee.address1 }},</span><br />
            <span class="franchiseeTable">{{ franchisee.country }} -{{ franchisee.pincode }}</span
            ><br />
            <span class="franchiseeTable">GST No. : {{ franchisee.gstNo }}</span
            ><br />
            <span class="franchiseeTable">Place Of Supply : {{ franchisee.state }}</span
            ><br />
            <span class="franchiseeTable">Contact Person : {{ franchisee.firstname + ' ' + franchisee.lastname }}</span
            ><br />
            <span class="franchiseeTable">Mobile No. : {{ franchisee.mobileno }}</span
            ><br />
            <span class="franchiseeTable">Business Partner’s Mobile No. : {{ franchisee.businessPartnerMobileno }}</span
            ><br />
            <span class="franchiseeTable">Invoice / Order No. : {{ invoiceDetail.orderID || '' }}</span
            ><br />
            <span class="franchiseeTable">Order Date : {{ invoiceDetail.orderDate || '' }}</span
            ><br />
            <span class="franchiseeTable">Invoice Date : {{ invoiceDetail.currentDate.toLocaleDateString() }}</span
            ><br />
            <span class="franchiseeTable">Total No. of Items : {{ invoiceDetail.products.length }}</span
            ><br />
          </td>
          <td align="right" width="50%">
            <span class="franchiseeTable"><img :src="logoUrl"/></span><br />
            <span class="franchiseeTable"><strong>{{ conditionalCompanyName(invoiceDetail.currentDate) }}</strong></span><br />
            <span class="franchiseeTable">{{ invoiceDetail.warehouse.WareHouseName }},</span><br />
            <span class="franchiseeTable">{{ invoiceDetail.warehouse.WareHouseAddress }},</span><br />
            <span class="franchiseeTable">{{ invoiceDetail.warehouse.WareHouseCity }} - {{ invoiceDetail.warehouse.PinCode }},({{ invoiceDetail.warehouse.WareHouseState }})</span><br />
            <span class="franchiseeTable">Contact No: {{ invoiceDetail.warehouse.ContactNo }} {{ invoiceDetail.warehouse.contactNumber1 ? 'or ' + invoiceDetail.warehouse.contactNumber1 : '' }}.</span><br />
          </td>
        </tr>
      </table>

      <br />
      <table class="invoiceTable" v-if="invoiceDetail.products.length">
        <thead>
          <tr>
            <td class="has-text-left has-text-weight-bold" rowspan="2">Item Code</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2" width="150">Item Name</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2" width="150">Item Desc</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">HSN Code</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">Qty</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">MRP</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">Discount</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">Base Cost</td>
            <td class="has-text-left has-text-weight-bold" colspan="2" v-if="invoiceDetail.displayIGST">IGST</td>
            <td class="has-text-left has-text-weight-bold" colspan="2" v-if="!invoiceDetail.displayIGST">CGST</td>
            <td class="has-text-left has-text-weight-bold" colspan="2" v-if="!invoiceDetail.displayIGST">SGST</td>
            <td class="has-text-left has-text-weight-bold" rowspan="2">Total(including Tax)</td>
          </tr>
          <tr>
            <td class="has-text-right has-text-weight-bold" v-if="invoiceDetail.displayIGST">Rate</td>
            <td class="has-text-right has-text-weight-bold" v-if="invoiceDetail.displayIGST">Amount</td>
            <td class="has-text-right has-text-weight-bold" v-if="!invoiceDetail.displayIGST">Rate</td>
            <td class="has-text-right has-text-weight-bold" v-if="!invoiceDetail.displayIGST">Amount</td>
            <td class="has-text-right has-text-weight-bold" v-if="!invoiceDetail.displayIGST">Rate</td>
            <td class="has-text-right has-text-weight-bold" v-if="!invoiceDetail.displayIGST">Amount</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in invoiceDetail.products" :key="index">
            <td class="has-text-right">{{ product.productid }}</td>
            <td class="has-text-right">{{ product.name ? product.name : '-' }}</td>
            <td class="has-text-right">{{ product.description ? product.description : '-' }}</td>
            <td class="has-text-right">{{ product.HSNCode }}</td>
            <td class="has-text-right">{{ product.quantity }}</td>
            <td class="has-text-right">{{ product.mrp ? Number(product.mrp).toFixed(2) : '-' }}</td>
            <td class="has-text-right">{{ product.discount ? Number(product.discount).toFixed(2) : '-' }}</td>
            <td class="has-text-right">{{ product.baseCost ? Number(product.baseCost).toFixed(2) : '-' }}</td>
            <td class="has-text-right" v-if="invoiceDetail.displayIGST">{{ product.IGST }}</td>
            <td class="has-text-right" v-if="invoiceDetail.displayIGST">{{ Number(product.igstAmount).toFixed(2) || 0 }}</td>
            <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ product.CGST }}</td>
            <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ Number(product.cgstAmount).toFixed(2) || 0 }}</td>
            <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ product.SGST }}</td>
            <td class="has-text-right" v-if="!invoiceDetail.displayIGST">{{ Number(product.sgstAmount).toFixed(2) || 0 }}</td>
            <td class="has-text-right">{{ product.totalPrice ? Number(product.totalPrice).toFixed(2) : '-' }}</td>
          </tr>
        </tbody>

      </table>
      <br /><br />
      <table>
          <tr v-if="invoiceDetail.displayIGST">
            <td class="has-text-left" colspan="10">
              <strong>Total IGST Amount:</strong>
            </td>
            <td class="has-text-right"><small class="rupeeSign">&#x20b9;</small>{{ Number(invoiceDetail.totalIGSTAmount).toFixed(2) || '0' }}</td>
          </tr>
          <tr v-if="!invoiceDetail.displayIGST">
            <td class="has-text-left" colspan="12">
              <strong>Total CGST Amount:</strong>
            </td>
            <td class="has-text-right"><small class="rupeeSign">&#x20b9;</small>{{ Number(invoiceDetail.totalCGSTAmount).toFixed(2) || '0' }}</td>
          </tr>
          <tr v-if="!invoiceDetail.displayIGST">
            <td class="has-text-left" colspan="12">
              <strong>Total SGST Amount:</strong>
            </td>
            <td class="has-text-right"><small class="rupeeSign">&#x20b9;</small>{{ Number(invoiceDetail.totalSGSTAmount).toFixed(2) || '0' }}</td>
          </tr>
          <tr>
            <td class="has-text-left" :colspan="invoiceDetail.displayIGST ? '10' : '12'">
              <strong>Grand Total:</strong>
            </td>
            <td class="has-text-right"><small class="rupeeSign">&#x20b9;</small>{{ Number(invoiceDetail.grandTotal).toFixed(2) }}</td>
          </tr>
        </table>
      <br /><br />
      <div class="franchiseeTable" v-if="invoiceDetail.warehouse">
        <strong>GST NO.:</strong> {{ invoiceDetail.warehouse.GSTNo }} <br />
        <strong>Registered Office:- Rajashree Business Park, Plot No 114,Survey No.338, Next to Sohrabh hall, Tadiwala Road,Pune 411001</strong><br />
        <strong>CIN:-U72100PN2010PTC136340 </strong>
      </div>
      <div class="franchiseeTable" align="center">
        <span class="franchiseeTable" v-if="invoiceDetail && invoiceDetail.image">
          <img :src="invoiceDetail.image" />
        </span>
      </div>
    </section>
  </div>
</template>

<script>
import Utils from '@/utils'
import moment from 'moment'

export default {
  name: 'OrderInvoice',
  props: {
    franchisee: Object,
    invoiceDetail: Object
  },
  data () {
    return {
      logoUrl: 'https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg'
    }
  },
  async created () {
    this.logoUrl = await Utils.helper.convertImgToBase64(this.logoUrl)
    this.invoiceDetail.currentDate = new Date()
    if (this.invoiceDetail.warehouse.WareHouseState.toLowerCase() !== this.franchisee.state.toLowerCase()) {
      this.invoiceDetail.displayIGST = true
    }
    this.invoiceDetail.products.forEach(invoice => {
      invoice.IGST = invoice.IGST ? Number(invoice.IGST) : 0
      invoice.CGST = invoice.IGST ? Number(invoice.IGST) / 2 : 0
      invoice.SGST = invoice.IGST ? Number(invoice.IGST) / 2 : 0

      if (invoice) {
        invoice.baseCost = Number(Number(invoice.actualPrice).toFixed(2))
        if (this.invoiceDetail.displayIGST) {
          invoice.igstAmount = invoice.baseCost - invoice.baseCost / (1 + Number(invoice.IGST / 100))
        } else {
          invoice.cgstAmount = invoice.baseCost - invoice.baseCost / (1 + Number(invoice.CGST / 100))
          invoice.sgstAmount = invoice.baseCost - invoice.baseCost / (1 + Number(invoice.SGST / 100))
        }
      }
    })

    this.invoiceDetail.orderDate =
      moment(this.invoiceDetail.orderDate).format('MMMM Do YYYY, h:mm:ss a') !== 'Invalid date' ? moment(this.invoiceDetail.orderDate).format('MMMM Do YYYY, h:mm:ss a') : this.invoiceDetail.orderDate
    this.invoiceDetail.grandTotal = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.totalPrice))
    this.invoiceDetail.grandTotal = Number(this.invoiceDetail.grandTotal).toFixed(2)
    if (this.invoiceDetail.displayIGST) {
      this.invoiceDetail.totalIGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.igstAmount))
    } else {
      this.invoiceDetail.totalSGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.sgstAmount))
      this.invoiceDetail.totalCGSTAmount = Utils.sumBy(this.invoiceDetail.products, obj => Number(obj.cgstAmount))
    }
  },
  methods: {
    isBefore (date1, date2) {
      let d1 = new Date(date1)
      let d2 = new Date(date2)
      return d1 < d2
    },
    conditionalCompanyName: function (date) {
      let companyName = ''
      if (this.isBefore(date, '2023-11-16T00:00:00.000Z')) {
        companyName = 'Brainbees Solutions Pvt Ltd'
      } else if (this.isBefore(date, '2024-04-01T00:00:00.000Z')) {
        companyName = 'Brainbees Solutions Limited (Formerly known as Brainbees Solutions Pvt Ltd)'
      } else {
        companyName = 'Brainbees Solution Limited'
      }
      return companyName
    }
  }
}
</script>

<style lang="css" scoped></style>
